import { Typography, Stack, Box, CircularProgress, Alert } from '@mui/material';
import { useLocation, useNavigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import AuthLayout from '../components/auth/AuthLayout';
import { useLang } from '../contexts/langContext';
import useLocalStorage from 'use-local-storage';

function YKOauthLandingPage() {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const code = searchParams.get('code');
  const state = searchParams.get('state');
  const provider = searchParams.get('provider');
  const [isAuthenticating, setIsAuthenticating] = useState(false);
  const [lang] = useLocalStorage('lang', 'zh-CN');
  const navigate = useNavigate();
  const { lang: contextLang } = useLang();
  
  // Use context lang if available, otherwise fall back to localStorage lang
  const currentLang = contextLang || lang;

  useEffect(() => {
    if (state) {
      document.cookie = `oauth_state_show=${state}; path=/`;
    }
    if (code && state && provider) {
      setIsAuthenticating(true);
      // Add a small delay to show the loading state
      setTimeout(() => {
        window.location.href = `/api/auth/oauth/callback?code=${code}&state=${state}&provider=${provider}`;
      }, 1000);
    }
  }, [code, state, provider]);

  const getTitle = () => {
    return currentLang === 'en' ? 'Authenticating...' : '正在验证...';
  };

  const getAuthenticatingMessage = () => {
    return currentLang === 'en' 
      ? 'Please wait while we authenticate your account.' 
      : '请稍候，我们正在验证您的账户。';
  };

  const getErrorMessage = () => {
    return currentLang === 'en'
      ? 'Authentication failed. Please try again.'
      : '验证失败，请重试。';
  };

  const getNoParametersMessage = () => {
    return currentLang === 'en'
      ? 'Missing authentication parameters. Please return to the login page.'
      : '缺少验证参数，请返回登录页面。';
  };

  const hasRequiredParams = code && state && provider;

  return (
    <AuthLayout title={getTitle()}>
      <Box sx={{ 
        display: 'flex', 
        flexDirection: 'column', 
        alignItems: 'center', 
        justifyContent: 'center',
        minHeight: '200px',
        textAlign: 'center'
      }}>
        {hasRequiredParams ? (
          <>
            {isAuthenticating ? (
              <Stack spacing={3} alignItems="center">
                <CircularProgress size={40} thickness={4} />
                <Typography 
                  variant="body1" 
                  sx={{ 
                    color: 'text.secondary',
                    fontWeight: 500
                  }}
                >
                  {getAuthenticatingMessage()}
                </Typography>
              </Stack>
            ) : (
              <Alert 
                severity="info" 
                variant="outlined"
                sx={{ 
                  mt: 2,
                  width: '100%',
                  textAlign: 'left'
                }}
              >
                {currentLang === 'en' 
                  ? 'Preparing authentication...' 
                  : '正在准备验证...'}
              </Alert>
            )}
          </>
        ) : (
          <Alert 
            severity="warning" 
            variant="outlined"
            sx={{ 
              mt: 2,
              width: '100%',
              textAlign: 'left'
            }}
          >
            {getNoParametersMessage()}
          </Alert>
        )}
      </Box>
    </AuthLayout>
  );
}

export default YKOauthLandingPage;
